import React from 'react';

/**
 * ColorblindFilters — invisible inline SVG that defines the daltonization
 * filters referenced by SettingsPanel.css (#cb-protanopia, #cb-deuteranopia,
 * #cb-tritanopia). Mounted once at App root.
 *
 * Color matrices from Brettel/Viénot/Mollon (1997) — the standard
 * approximations used by Color Oracle, Stark, and most accessibility
 * tools. Applied via CSS `filter: url(#id)`.
 */
const ColorblindFilters = () => (
  <svg
    aria-hidden="true"
    style={{
      position: 'absolute',
      width: 0,
      height: 0,
      overflow: 'hidden',
      pointerEvents: 'none',
    }}
  >
    <defs>
      <filter id="cb-protanopia">
        <feColorMatrix
          type="matrix"
          values="
            0.567 0.433 0     0 0
            0.558 0.442 0     0 0
            0     0.242 0.758 0 0
            0     0     0     1 0"
        />
      </filter>
      <filter id="cb-deuteranopia">
        <feColorMatrix
          type="matrix"
          values="
            0.625 0.375 0     0 0
            0.7   0.3   0     0 0
            0     0.3   0.7   0 0
            0     0     0     1 0"
        />
      </filter>
      <filter id="cb-tritanopia">
        <feColorMatrix
          type="matrix"
          values="
            0.95  0.05  0     0 0
            0     0.433 0.567 0 0
            0     0.475 0.525 0 0
            0     0     0     1 0"
        />
      </filter>
    </defs>
  </svg>
);

export default ColorblindFilters;
